import type { SeedFile } from '@/versions/v1/shared/files-seed';

export type FileSortKey = 'name' | 'updated';

export function filterFiles(
  files: SeedFile[],
  query: string,
  folder: string | null,
): SeedFile[] {
  const needle = query.trim().toLowerCase();
  return files.filter((file) => {
    if (folder && file.folder !== folder) return false;
    if (!needle) return true;
    return `${file.name} ${file.meta} ${file.folder}`.toLowerCase().includes(needle);
  });
}

export function sortFiles(files: SeedFile[], sortKey: FileSortKey): SeedFile[] {
  const copy = [...files];
  if (sortKey === 'updated') {
    copy.sort((a, b) => b.updatedAt - a.updatedAt);
    return copy;
  }
  copy.sort((a, b) => a.name.localeCompare(b.name));
  return copy;
}

export function groupFilesByFolder(files: SeedFile[]): Record<string, SeedFile[]> {
  return files.reduce<Record<string, SeedFile[]>>((acc, file) => {
    acc[file.folder] = acc[file.folder] ?? [];
    acc[file.folder].push(file);
    return acc;
  }, {});
}
